import React, { useState } from 'react'
import { Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { DF_OT0012Context } from './context'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import { fnGetValueByKey } from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'
import useGetCsrfToken from '../../Hooks/useGetCsrfToken'

const DF_OT0012 = () => {
  const { userProfile, isModalPage, accessToken } = useSelector(state => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
    accessToken: state.login.user.access_token
  }))

  const csrfToken = useGetCsrfToken();  

  const [isLoading, setisLoading] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState('')
  const [filteredData, setFilteredData] = useState([])
  const [columns, setColumns] = useState([])
  // const [columns, setColumns] = useState([
  //   { field: "Status", header: "Status", hasImage: true, hidden: false },
  //   { field: "Protocolo", header: "Protocolo", hidden: false },
  //   { field: "Tipo_Agendamento", header: "Tipo Ag.", hidden: false },
  //   { field: "Fornecedor", header: "Fornecedor", hidden: true },
  //   { field: "Destino", header: "Destino", hasImage: true, hidden: true},
  //   { field: "Desembarque", header: "Desembarque", hidden: true },
  //   { field: "SKUs", header: "SKUs", hidden: true },
  //   { field: "Qtde_SKUs", header: "Qtd. SKUS", hidden: true },
  //   { field: "Qtde_Volumes", header: "Qt. Vol.", hidden: true },
  //   { field: "Categoria", header: "Categoria", hidden: true },
  //   { field: "Peso_Total", header: "Peso", hidden: true },
  //   { field: "Valor", header: "Valor", hidden: true },
  //   { field: "Dt_Agend", header: "Dt. Agend.", hidden: true },
  //   { field: "Coluna_Funcoes", header: "", width: '5%', hasImage: true, Export: false, hidden: true },
  // ])

  return (
    <React.Fragment>
      <DF_OT0012Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData,
          columns,
          setColumns,
          accessToken,
          csrfToken
        }}
      >
        <div style={{ padding: isModalPage && '0px', overflow: isModalPage && 'hidden' }} className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader context={DF_OT0012Context} />
            <GridBody />
          </Container>
        </div>
      </DF_OT0012Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(DF_OT0012)
